export default class BasePreferencesProvider {
  static async getMap() {
    throw new Error('Method getMap not implemented');
  }

  static async setKey() {
    throw new Error('Method setKey not implemented');
  }
}
